import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-question-answer-line"></i>
            常见问题
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于51吃瓜网的常见疑问</p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm font-medium text-foreground-800 pr-2">{item.q}</h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${
                  openIdx === idx ? 'bg-primary-100 text-primary-600' : 'bg-background-200 text-foreground-400'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIdx === idx ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}